import Vue from "vue";
import AppComponent from "./App.vue";

import "@/assets/core/element.io";
import "@/assets/css/style.css";

Vue.component("app-component", AppComponent);

new Vue({
  el: "#app",
  render: createElement => {
    return createElement(AppComponent);
  }
});
